export function removeHTML(str){ 
    var tmp = document.createElement("div");
    tmp.innerHTML = str;
    return tmp.textContent || tmp.innerText || "";
}